import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

function TemplateCardSkeleton({ count = 4 }) {
  return (
    <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
      {Array.from({ length: count }).map((_, index) => (
        <Card key={index}>
          <CardHeader className="pb-2">
            <div className="flex justify-between items-center">
              <Skeleton className="h-5 w-44" />
              <Skeleton className="h-7 w-7 rounded-full" />
            </div>
          </CardHeader>
          <CardContent className="pb-4 mt-4">
            <div className="space-y-4">
              <Skeleton className="h-[260px] w-full rounded-sm" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-4 w-1/2" />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

export default TemplateCardSkeleton;
